import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0d55a3a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { buildLineAreaStyle, ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { useI18n } from 'vue-i18n'
import { getElColorPrimary, getElColorPrimaryRgba } from '@/utils/theme-color'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'

interface ChartData {
  times: string[]
  counts: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'software-activity-trend-chart',
  props: {
    data: { default: () => ({
    times: [],
    counts: []
  }) }
  },
  emits: ["timeRangeChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)
const { t, locale } = useI18n()

const cardTitle = computed(() => {
  void locale.value
  return t('softwareUsage.activityTrendCardTitle')
})

const chartData = computed(() => props.data)
const timeRange = ref<TimeRange>(TimeRange.DAYS_30)
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const chartOption = computed(() => {
  void locale.value
  if (!chartData.value?.times?.length) {
    return { xAxis: { data: [] }, series: [] }
  }

  return {
    xAxis: {
      data: chartData.value.times,
    },
    series: [withLineSeriesStyle({
      name: t('softwareUsage.activityTrendSeriesName'),
      data: chartData.value.counts,
      areaStyle: buildLineAreaStyle(ECHARTS_LINE_COLOR.blue),
      smooth: true,
      type: 'line',
    }, ECHARTS_LINE_COLOR.blue)]
  }
})

function initChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
}

function renderChart() {
  if (!chartInstance) return
  const finalOption: any = getAssignLineOption(chartOption.value, { unit: t('softwareUsage.chartUnitTimes') })
  chartInstance.setOption(finalOption)
}

function handleTimeRangeChange(value: TimeRange) {
  emit('timeRangeChange', value)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  if (!chartData.value?.times?.length) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

watch(locale, () => {
  if (chartInstance && chartData.value?.times?.length) {
    renderChart()
  }
})

useEchartsThemeSync(renderChart)

onMounted(() => {
  if (chartData.value?.times?.length) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: cardTitle.value,
    class: "software-activity-trend-chart-wrap"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        onChange: handleTimeRangeChange
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-wrapper"
        }, null, 512)
      ], 512), [
        [_vShow, chartData.value?.times?.length]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "292px",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !chartData.value?.times?.length]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})